require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-power-ai-and-bots.json") })
        }
      }, "path---post-power-ai-and-bots");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-power-ai-and-bots!./.cache/json/post-power-ai-and-bots.json
// module id = 349
// module chunks = 231608221292675